import produce from 'immer';

export type Ratings = {
  id: string;
  templateType: 'ratings';
  maxLabel: {
    update: (html: string) => void;
    text: string;
  };
  minLabel: {
    update: (html: string) => void;
    text: string;
  };
  question: {
    update: (html: string) => void;
    text: string;
  };
};

const paramsMap = {
  minLabel: 'min-label',
  maxLabel: 'max-label',
  question: 'question',
};

export default function rating({ item, setItem, itemsService }): Ratings {
  const updateText = (el, text) => {
    setItem((prevItem) =>
      produce(prevItem, (draft) => {
        draft[el].text = String(text);
      })
    );

    itemsService.update({
      pathParams: { id: item.id },
      data: { data: { attributes: { [paramsMap[el]]: String(text) } } },
    });
  };

  return {
    id: item.id,
    templateType: 'ratings',
    maxLabel: {
      update: (text) => updateText('maxLabel', text),
      text: item.maxLabel,
    },
    minLabel: {
      update: (text) => updateText('minLabel', text),
      text: item.minLabel,
    },
    question: {
      update: (text) => updateText('question', text),
      text: item.question,
    },
  };
}
